module.exports = __webpack_public_path__ + "img/scorecard.32e39172.png";